import { render, staticRenderFns } from "./AddBOM.vue?vue&type=template&id=1791b59c&scoped=true&"
import script from "./AddBOM.vue?vue&type=script&lang=js&"
export * from "./AddBOM.vue?vue&type=script&lang=js&"
import style0 from "./AddBOM.vue?vue&type=style&index=0&id=1791b59c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1791b59c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1791b59c')) {
      api.createRecord('1791b59c', component.options)
    } else {
      api.reload('1791b59c', component.options)
    }
    module.hot.accept("./AddBOM.vue?vue&type=template&id=1791b59c&scoped=true&", function () {
      api.rerender('1791b59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/jobcard/jobcard-view/components/AddBOM.vue"
export default component.exports